import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  focusAfterTimeout,
  getIcon,
  normalizeSalesforceId,
  currentUserIsSuperAdmin,
  Firebase,
} from '../../util';

import { createUser, updateUserWithRole, stopEditingUser, resendUserInvitation } from '../../actions/users';

import Select from 'react-select';
import { Switch } from '../shared';
import ReactTooltip from 'react-tooltip';

import { IntegrationSelector } from '../../selectors';

const DEFAULT_USER = {
  firstName: '',
  lastName: '',
  email: '',
  role: 'employee',
  salesforceId: null,
  salesforceIdAlternative: null,
  pendingAssessment: null
}

class UpdateUserModal extends Component{

  state = {
    editingUser: DEFAULT_USER,
    error: null,
    message: null,
    sendWelcomeEmailIfNewUser: false,
    confirmingDelete: false,
  }

  componentWillMount(){
    this.setState({
      confirmingDelete: false
    });
  }

  componentWillReceiveProps(nextProps){
    console.log('component received nextprops: ', nextProps);

    //const editingUser = { ...nextProps.editingUser.user };

    const errorForState = nextProps.editingUser.error || null;
    const messageForState = nextProps.editingUser.message || null;
    const userDataForState = nextProps.editingUser.user || DEFAULT_USER;

    console.log('userDataForState: ', userDataForState);

    this.setState({
      editingUser: userDataForState,
      error: errorForState,
      message: messageForState,
    });

    //focus first input
    if(nextProps.editingUser && nextProps.editingUser.editing){
      focusAfterTimeout(this, 'firstNameInput');
    }

    //
    // if(editingUser){
    //   userDataForState = edit
    //   console.log('editing user: ', editingUser);
    //   this.setState({
    //     editingUser
    //   });
    // }
    // else{
    //   this.setState({
    //     editingUser: DEFAULT_USER
    //   });
    // }
    //
    // if(nextProps.editingUser.error){
    //   errorForState
    // }
    // else{
    //   this.setState({
    //     error: null
    //   });
    // }
  }

  updateUserField(fieldName, fieldValue){
    this.clearErrorAndMessage();

    let updatedUser = {
      ...this.state.editingUser
    }
    updatedUser[fieldName] = fieldValue;

    this.setState({
      editingUser: updatedUser
    });
  }

  clearErrorAndMessage(){
    this.setState({
      error: null,
      message: null,
    });
  }

  createOrUpdateUser(){
    if(this.state.editingUser._id){
      this.props.updateUserWithRole(this.state.editingUser);
    }
    else{
      this.props.createUser(this.state.editingUser, this.state.sendWelcomeEmailIfNewUser);
    }
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else if(this.state.message){
      return <div className="form-message success">{this.state.message}</div>;
    }
    else{
      return <div className="form-message placeholder">&nbsp;</div>;
    }
  }

  formIsDirty(){

    const { userIsNew, user } = this.props.editingUser;

    if( userIsNew ||
      user.firstName !== this.state.editingUser.firstName ||
      user.lastName !== this.state.editingUser.lastName ||
      user.role !== this.state.editingUser.role ||
      user.salesforceId !== this.state.editingUser.salesforceId ||
      user.salesforceIdAlternative !== this.state.editingUser.salesforceIdAlternative ||
      !_.isEqual(user.pendingAssessment, this.state.editingUser.pendingAssessment)
     ){
       return true;
     }
    else{
      return false;
    }
  }

  getSaveButtonText(){
    const { syncingWithServer, userIsNew } = this.props.editingUser;

    if(userIsNew){
      if(syncingWithServer){
        return "Creating user...";
      }
      else{
        return "Create new user";
      }
    }
    else{
      if(syncingWithServer){
        return "Saving...";
      }
      else{
        return "Save";
      }
    }

  }

  toggleWelcomeEmailSend(){
    this.setState({
      sendWelcomeEmailIfNewUser: !this.state.sendWelcomeEmailIfNewUser
    });
  }

  renderSendWelcomeEmailSwitch(){
    const { userIsNew } = this.props.editingUser;

    if(!userIsNew){
      return null;
    }

    return (
      <div className="form-group">
        <label htmlFor="send-welcome-email">Send welcome email?</label>
        <p style={{marginTop: 0, marginBottom: 8}}><small>This email will include a link for the user to setup their account/password. If you would like to postpone account creation to their account, then you can send this to them later. Toggle this "On" to send them their account setup email now.</small></p>
        <Switch
          id="some-switch"
          checked={this.state.sendWelcomeEmailIfNewUser}
          onChange={this.toggleWelcomeEmailSend.bind(this)}
          ></Switch>
      </div>
    );
  }

  matchingPendingAssessmentOption(options, value){
    return _.find(options, option => {
      if(!option.value && !value){
        //if both falsey values
        return true
      }
      //else if value, check if it matches any of the options
      else if(option.value && value && value.assessmentName && value.profileName){
        console.log('1: ', value.assessmentName);
        console.log('3: ', value.profileName);
        console.log('3: ', option.value.assessmentName);
        console.log('4: ', option.value.profileName);
        return value.assessmentName === option.value.assessmentName && value.profileName === option.value.profileName;
      }
    });
  }

  renderPendingAsessmentSectionForSuperAdmin(){

    if(!currentUserIsSuperAdmin()){
      return null;
    }
    else if(!this.props.editingUser.user){
      return null;
    }

    const organizationAssessments = _.filter(this.props.assessmentConfigs || [], { organization: this.props.organization._id });

    let assessmentProfileCombinations = [];

    _.each(organizationAssessments, assessmentConfig => {
      _.each(assessmentConfig.profileNames, (profileId, profileName) => {
        assessmentProfileCombinations.push({
          value: {
            assessmentName: assessmentConfig.name,
            profileName,
          },
          label: `${assessmentConfig.name}: ${profileName}`,
        });
      });
    });

    const pendingAssessmentOptions = [{
      value: null,
      label: 'No Pending Assessment',
    }, ...assessmentProfileCombinations];

    console.log('pendingAssessmentOptions: ', pendingAssessmentOptions);
    console.log('this.state.editingUser.pendingAssessment: ', this.state.editingUser.pendingAssessment);

    const currentlySelectedOption = this.matchingPendingAssessmentOption(pendingAssessmentOptions, this.state.editingUser.pendingAssessment);
    console.log('currentlySelectedOption: ', currentlySelectedOption);

    return (
      <div className="form-section">
        <div className="form-section-label">Pending Assessment Setup</div>
        <p style={{ width: 'calc(100% - 325px)' }}>Select an assessment + profile combination to queue up for this user to take. If this user is already in progress on an assessment, or has completed a pending assessment, manual adjustment is needed.</p>
        <Select
          placeholder={`Setup pending assessment...`}
          classNamePrefix={'react-select'}
          className='react-select-container min-width-300'
          value={currentlySelectedOption}
          options={pendingAssessmentOptions}
          onChange={(option) => { this.updateUserField('pendingAssessment', option.value); }}
          isSearchable={true}
          isDisabled={this.props.editingUser.user.pendingAssessment && this.props.editingUser.user.pendingAssessment.status}
        />
      </div>
    )
  }

  inviteUser(){
    this.props.resendUserInvitation(this.state.editingUser._id);
  }

  fixSalesforceId(){
    const { salesforceId } = this.state.editingUser;

    this.updateUserField('salesforceId', normalizeSalesforceId(salesforceId));
  }
  fixSalesforceIdAlternative(){
    const { salesforceIdAlternative } = this.state.editingUser;

    this.updateUserField('salesforceIdAlternative', normalizeSalesforceId(salesforceIdAlternative));
  }

  renderEditForm(){

    const { _id, firstName, lastName, email, role, salesforceId, salesforceIdAlternative } = this.state.editingUser;

    const isEmployee = role === 'employee';
    const isManager = role === 'manager';
    const isSalesLeader = role === 'salesleader';
    const isAssessmentAdmin = role === 'assessmentadmin';
    const isAdmin = role === 'admin';

    const isNewUser = _id ? false : true;

    const { integration } = this.props;

    const { syncingWithServer } = this.props.editingUser;

    const cachedRoleIsAdmin = (this.props.editingUser.user || {}).role === 'admin' || (this.props.editingUser.user || {}).role === 'assessmentadmin';

    return (
      <form className="velocity-form">
        <h2>{isNewUser ? 'Add' : 'Update'} user</h2>
        {this.renderFormMessage()}
        <div className="form-group">
          <div className="input-group half-width">
            <label htmlFor="velocity-new-user-first-name">First name</label>
            <input
              ref={input => { this.firstNameInput = input; }}
              id="velocity-new-user-first-name"
              autoComplete="off"
              type="text"
              value={firstName}
              onChange={e => {this.updateUserField('firstName', e.target.value)}}
              />
          </div>
          <div className="input-group half-width">
            <label htmlFor="velocity-new-user-last-name">Last name</label>
            <input
              id="velocity-new-user-last-name"
              autoComplete="off"
              type="text"
              value={lastName}
              onChange={e => {this.updateUserField('lastName', e.target.value)}}
              />
          </div>
        </div>
        {integration === 'salesforce' &&
          <div className="form-group">
            <label htmlFor="velocity-new-user-salesforce-id">{getIcon('salesforce')}<span>Salesforce Id</span></label>
            <input
              id="velocity-new-user-salesforce-id"
              type="text"
              value={salesforceId || ''}
              onChange={e => {this.updateUserField('salesforceId', e.target.value)}}
              />
            {salesforceId && salesforceId.length === 15 &&
              <div onClick={this.fixSalesforceId.bind(this)} className="fix-field-prompt" >{getIcon('wand')}<span>Invalid format, click to fix</span></div>
            }
          </div>
        }
        {integration === 'salesforce' &&
          <div className="form-group">
            <label htmlFor="velocity-new-user-alt-salesforce-id">{getIcon('salesforce')}<span>Alt Salesforce Id</span></label>
            <input
              id="velocity-new-user-alt-salesforce-id"
              type="text"
              value={salesforceIdAlternative || ''}
              onChange={e => {this.updateUserField('salesforceIdAlternative', e.target.value)}}
              />
            {salesforceIdAlternative && salesforceIdAlternative.length === 15 &&
              <div onClick={this.fixSalesforceIdAlternative.bind(this)} className="fix-field-prompt" >{getIcon('wand')}<span>Invalid format, click to fix</span></div>
            }
          </div>
        }
        <div className="form-group">
          <label htmlFor="velocity-new-user-email">Email Address</label>
          <input
            id="velocity-new-user-email"
            className="fs-block"
            type="email"
            value={email}
            disabled={!isNewUser}
            onChange={e => {this.updateUserField('email', e.target.value)}}
            />
          {!isNewUser && !syncingWithServer &&
            <div className="input-action" onClick={this.inviteUser.bind(this)}>Resend Invite</div>
          }
        </div>
        {this.renderSendWelcomeEmailSwitch()}
        {this.renderPendingAsessmentSectionForSuperAdmin()}
        <div className="form-section">
          <div className="form-section-label">Permissions</div>
            <div className="form-group">
              <div className="input-group fifth-width" style={{paddingLeft: '50px'}}>
                <label>Seller</label>
                <Switch
                  id="some-switch"
                  disabled={cachedRoleIsAdmin && !isNewUser}
                  checked={isEmployee}
                  onChange={checked => { if(checked){ this.updateUserField('role', 'employee'); } }}
                />
              </div>
              <div className="input-group fifth-width" style={{paddingLeft: '50px'}}>
                <label>Manager</label>
                <Switch
                  id="some-switch"
                  disabled={cachedRoleIsAdmin && !isNewUser}
                  checked={isManager}
                  onChange={checked => { if(checked){ this.updateUserField('role', 'manager'); } }}
                />
              </div>
              <div className="input-group fifth-width" style={{paddingLeft: '50px'}}>
                <label>Sales Leader</label>
                <Switch
                  id="some-switch"
                  disabled={cachedRoleIsAdmin && !isNewUser}
                  checked={isSalesLeader}
                  onChange={checked => { if(checked){ this.updateUserField('role', 'salesleader'); } }}
                />
              </div>
              <div className="input-group fifth-width" style={{paddingLeft: '50px'}}>
                <label>Assessment Admin</label>
                <Switch
                  id="some-switch"
                  disabled={!currentUserIsSuperAdmin() || (cachedRoleIsAdmin && !isNewUser)}
                  checked={isAssessmentAdmin}
                  onChange={checked => { if(checked){ this.updateUserField('role', 'assessmentadmin'); } }}
                />
              </div>
              <div className="input-group fifth-width" style={{paddingLeft: '50px'}}>
                <label>Full Admin</label>
                <Switch
                  id="some-switch"
                  disabled={!currentUserIsSuperAdmin() || (cachedRoleIsAdmin && !isNewUser)}
                  checked={isAdmin}
                  onChange={checked => { if(checked){ this.updateUserField('role', 'admin'); } }}
                />
              </div>
              <p>&nbsp;</p>
              <p style={{opacity: isEmployee ? 1 : .5}}>Sellers can log in and view their own account, as well as be added to teams by admins.</p>
              <p style={{opacity: isManager ? 1 : .5}}>Managers can view employee information for employees added to their teams</p>
              <p style={{opacity: isSalesLeader ? 1 : .5}}>Sales Leaders can view data and reporting for all employees, managers, teams, and the organization as a whole</p>
              <p style={{opacity: isAssessmentAdmin ? 1 : .5}}>Assessment Admins can view talent information (assessment results, selection reports, etc.) for all employees, managers, teams, and the organization as a whole</p>
              <p style={{opacity: isAdmin ? 1 : .5}}>Admins have all other permissions and can also create and manage all users and teams in the organization</p>
            </div>
        </div>
      </form>
    )
  }

  renderConfirmDeleteMessage(){
    return (
      <div className="velocity-form">
        <h2>Archive {this.state.editingUser.firstName} {this.state.editingUser.lastName}?</h2>
        <p>This person will no longer be able to access this app, or any data in your organization. They will be preserved in reports, but will be removed from all current team, sprint, talent, etc. views.</p>
        <p><b>We strongly recommend transferring or deleting all of this person's open deals.</b></p>
      </div>
    )
  }

  renderEditActions(){

    const { syncingWithServer } = this.state;

    return (
      <div className="modal-actions">
        {!this.formIsDirty() && !syncingWithServer &&
          <button className="button primary" onClick={this.props.stopEditingUser}>Done</button>
        }
        {(this.formIsDirty() || syncingWithServer) &&
          <template>
            <button className="button primary" onClick={this.createOrUpdateUser.bind(this)} disabled={syncingWithServer}>{this.getSaveButtonText()}</button>
            <button className="button grey-button" onClick={this.props.stopEditingUser}>Cancel</button>
          </template>
        }
        {!this.formIsDirty() && !syncingWithServer &&
          <button className="button transparent-button sm secondary" onClick={() => { this.setState({ confirmingDelete: true }) }}>Archive user...</button>
        }
      </div>
    )
  }

  archiveUser(){
    console.log('testing archiveUser...');

    const callable = Firebase.functions().httpsCallable('archiveOrganizationUser');

    callable({ userId: this.state.editingUser._id }).then(result => {
      console.log('user archived!: ', result.data);
      this.props.stopEditingUser();
      //reload data on page?
    }).catch(err => {
      this.setState({
        confirmingDelete: false,
        error: err.message,
      });
    });
  }

  renderDeleteActions(){

    const { syncingWithServer } = this.state;

    return (
      <div className="modal-actions">
        {!syncingWithServer &&
          <button className="button danger-button" onClick={this.archiveUser.bind(this)}>Archive user</button>
        }
        {!syncingWithServer &&
          <button className="button grey-button" onClick={() => { this.setState({ confirmingDelete: false })  } }>Nevermind</button>
        }
      </div>
    )
  }

  render(){

    if(!this.props.editingUser.editing){
      return null;
    }

    const {
      confirmingDelete
    } = this.state;

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.stopEditingUser}>X</div>
          <div className="modal-content">
            {!confirmingDelete && this.renderEditForm()}
            {confirmingDelete && this.renderConfirmDeleteMessage()}
          </div>
          {!confirmingDelete && this.renderEditActions()}
          {confirmingDelete && this.renderDeleteActions()}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    editingUser: state.editingUser,
    organization: state.organization.data,
    integration: IntegrationSelector(state),
    assessmentConfigs: state.assessmentConfigs.data,
  }
}

export default connect(mapStateToProps, { stopEditingUser, createUser, updateUserWithRole, resendUserInvitation })(UpdateUserModal);



// WEBPACK FOOTER //
// ./src/components/modals/updateUser.js